export { default as enrollmentsLocaleEn } from './localeEn';
export { default as enrollmentsLocaleEs } from './localeEs';
export { default as enrollmentsLocalePt } from './localePt';
